<template>
    <div class="wizard-submit-wrapper">
        <div class="wizard-submit-wrapper--continue" v-show="showContinue">
            <button class="btn btn__medium btn__primary" @click="onContinue">
                <slot name="continue_label"/>
            </button>
        </div>
        <div v-show="!showContinue">
            <slot name="submit" :enhancedOnFormSubmit="enhancedOnFormSubmit"/>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex';
    import * as invokeMethods from './helpers';
    import { INSTANCES, MODAL_CONFIG } from './overlay-instances';
    import OverlayRecipeDialog from '../overlay-recipe-dialog/overlay-recipe-dialog';
    import Vue from 'vue';

    Vue.component('OverlayRecipeDialog', OverlayRecipeDialog);

    export default {
        props: {
            currentStep: {
                type: Number,
                required: true,
            },
            generalErrors: {
                type: Array,
                required: true,
            },
            onFormSubmit: {
                type: Function,
                required: true,
            },
        },
        computed: {
            ...mapState('wizard', ['currentSubStep', 'useEnroleeBillingAddress', 'showLegalGuardian1', 'showLegalGuardian2']),
            showContinue() {
                if (this.currentStep !== 2) {
                    return false;
                }

                switch (this.currentSubStep) {
                    case 0:
                        return !!(!this.useEnroleeBillingAddress || this.showLegalGuardian1 || this.showLegalGuardian2);
                    case 1:
                        return !!(this.showLegalGuardian1 || this.showLegalGuardian2);
                    case 2:
                        return !!this.showLegalGuardian2;

                    case 3:
                        return false;
                    default:
                        return false;
                }
            },
        },
        methods: {
            ...mapActions('wizard', ['updateWizardSubStep', 'updateWizardErrors']),
            ...mapActions('vue-ui/overlay', ['openOverlay', 'closeOverlay']),
            onContinue() {
                const subSteps = [true, this.useEnroleeBillingAddress, this.showLegalGuardian1, this.showLegalGuardian2];
                const nextSubStep = subSteps.reduce((acc) => {
                    if (subSteps[acc]) {
                        return acc;
                    }

                    return acc + 1;
                }, this.currentSubStep + 1);

                this.updateWizardSubStep({ value: nextSubStep });
            },
            enhancedOnFormSubmit() {
                this.onFormSubmit();
            },
            open(type) {
                const { fn, props, facets } = MODAL_CONFIG[type];

                const Feedback = invokeMethods[fn](this.openOverlay, props, facets);

                if (Feedback) {
                    Feedback.then(
                        () => {
                            window.location.reload();
                            this.closeOverlay({ id: INSTANCES.MODAL, transition: 'trs-simple-fade' });
                        },
                        () => {
                            this.closeOverlay({ id: INSTANCES.MODAL, transition: 'trs-simple-fade' });
                        },
                    );
                }
            },
        },
        mounted() {
            // Trigger mockup service error
            // this.$watch('generalErrors', (value) => {
            //     if (value.length) {
            //         this.open('MODAL_CHOICE');
            //     }
            // });
        },
    };
</script>
